export var LineTypeEnum;
(function (LineTypeEnum) {
    LineTypeEnum["appointment"] = "appointment";
    LineTypeEnum["bonus"] = "bonus";
    LineTypeEnum["paperwork"] = "paperwork";
    LineTypeEnum["other"] = "other";
})(LineTypeEnum || (LineTypeEnum = {}));
export var LineTypeMock = {
    id: '82779b82-f9fa-4a28-8a54-e97e2f0b0335',
    calculated_amount_cents: 19784,
    calculated_amount_currency: 'USD',
    override_amount_cents: 0,
    override_amount_currency: 'USD',
    pay_amount_cents: 0,
    pay_amount_currency: 'USD',
    denial_reason: null,
    description: 'Adult Therapy Follow Up, Telehealth, Completed',
    line_type: 'appointment',
    service_provided: 'Adult Therapy Follow Up',
    appointment_id: '7c90a8c4-5efe-43f7-9e97-aa3af07314a8',
    provider_id: 'b0e3c858-e005-457e-8209-06f505a2cf86',
    member_id: null,
    appointment_note_signed_on: null,
    appointment_method: 'Telehealth',
    appointment_status: 'Completed',
    date_of_service: '2023-03-01',
    created_on: '2023-02-28',
    updated_on: '2023-02-28',
};
